export const passwordPattern =
  "^(?=.*)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])[^ ]{8,32}$";
export const vatIdPattern = "^[a-zA-Z0-9]{5,15}$";
export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const CAN_MANAGE_DATA_MANAGEMENT = [
  "tamarp@way2vat.com",
  "vaniab@way2vat.com",
  "mayaw@way2vat.com",
  "elirand@way2vat.com",
  "roya@way2vat.com",
  "savovicmarko986@gmail.com",
  "idanh@way2vat.com",
  "bogdan.ksonov@way2vat.com",
  "mayaw+marko@way2vat.com",
];
